import { Button } from "antd";
import React, { useContext, useEffect, useState } from "react";
import Cargando from "../components/Cargando";
import { signOut } from "../firebase/auth";
import { contextApp } from "../firebase/context";
import { getColection } from "../firebase/fireStore";
import NavigationUsers from "./NavigationUsers";

const Navigation = () => {
  const { usuario } = useContext(contextApp);
  const [psicologies, setPsicologies] = useState([]);
  const [estado, setEstado] = useState([]);

  const getProfesionales = async () => {
    const response = Array.from(await getColection("Users")) || [];
    const filterPs = response.filter((res) => res.data.email === usuario.email);
    const typeUser = filterPs.map((res) => res.data.typeUser.value);
    setPsicologies(typeUser);
    const typePs = filterPs.map((res) => res.data.estado);
    setEstado(typePs);
  };

  useEffect(() => {
    getProfesionales();
  }, [usuario]);

  return (
    <>
      {psicologies.length > 0 ? (
        psicologies[0] === "paciente" ? (
          <NavigationUsers />
        ) : estado[0] === true ? (
          <div>
            Psicólogo Habilitado{" "}
            <Button
              onClick={async () => {
                await signOut();
              }}
            >
              Salir
            </Button>
          </div>
        ) : (
          <div>
            Por habilitar{" "}
            <Button
              onClick={async () => {
                await signOut();
              }}
            >
              Salir
            </Button>
          </div>
        )
      ) : (
        <Cargando />
      )}
    </>
  );
};

export default Navigation;
